import React from "react";
import { StarIcon, BadgeCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { testimonials } from "../data/content";
function Stars({
  size = "h-5 w-5"
}: {
  size?: string;
}) {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-283" data-mp="3fym86mxaf65e">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-gold text-gold`} aria-hidden="true" data-id="element-284" data-mp="3b01g5as6vss1" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-285" data-mp="31zd0ycr27mdk">
      <div className="mx-auto max-w-5xl" data-id="element-286" data-mp="2x0jqkt72kbhm">
        <h2 id="testimonials-title" className="text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-287" data-mp="2x1bjfw9a7v47">
          What other <em className="text-wine-700" data-id="element-288" data-mp="v9gb9qm8i8qq">professionals are saying</em>
        </h2>
        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-289" data-mp="v7c8xd3zhhsk">
          <div className="flex items-center gap-3" data-id="element-290" data-mp="qbeqn195u1d5">
            <span className="font-serif text-4xl font-extrabold text-ink" data-id="element-291" data-mp="h5y6q955730z">4.9/5</span>
            <Stars size="h-6 w-6" data-id="element-292" data-mp="h8aytf4m6trr" />
          </div>
          <p className="text-center text-[15px] text-ink-soft" data-id="element-293" data-mp="m62os3lp85tb">Rated by orthodontic professionals who purchased BIOMECHANICS WAR ROOM™</p>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-294" data-mp="7a4z946a5zq2">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-cream p-6 ring-1 ring-wine-100" data-id="element-295" data-mp="c8ol74kvjbif">
              <Stars data-id="element-296" data-mp="zyseai0frsv6" />
              <blockquote className="mt-4 text-[17px] leading-relaxed text-ink" data-id="element-297" data-mp="14w29yfef50rg">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-4 pt-6" data-id="element-298" data-mp="q765stfhg7w4">
                <img src={t.photo} alt={`Photo of ${t.name}`} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-white" loading="lazy" data-id="element-299" data-mp="q4s96g55mnmg" />
                <div className="min-w-0" data-id="element-300" data-mp="1iuigo6ca6r9l">
                  <p className="flex items-center gap-1.5 font-bold text-ink" data-id="element-301" data-mp="1ith39v7slsop">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-cta" aria-label="Verified buyer" data-id="element-302" data-mp="1xi0lr5tr9nwj" />
                  </p>
                  <p className="text-sm text-ink-soft" data-id="element-303" data-mp="1siec16d4ypsh">
                    {t.role} · <span aria-hidden="true" data-id="element-304" data-mp="1sh3896joxi1d">{t.flag}</span> {t.country}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-305" data-mp="1jhpu40kmg5ab">
          <CtaButton label="I want to train my biomechanical judgment" data-id="element-306" data-mp="1ej4ua29a7nme" />
        </div>
      </div>
    </section>;
}